import React from 'react';
import LeftRight from "../../components/ui/LeftRight";
import {useTranslation} from "react-i18next";
import {productCards} from "../../constants/products/environmentalMoniroring";
import {environmentalMonitoring} from "../../constants/meta";
import Meta from "../../components/common/Helmet";

const EnvironmentalMonitoring = () => {
  const { t } = useTranslation();
  return (
    <div>
      <Meta
        title={environmentalMonitoring.title}
        description={environmentalMonitoring.description}
        canonical={environmentalMonitoring.canonical}
        keywords={environmentalMonitoring.keywords}
        ogTitle={environmentalMonitoring.title}
        ogDescription={environmentalMonitoring.description}
      />
      <div className="md:w-theme-container w-mobile-container mx-auto mt-20">
        <h2 className="text-center md:w-[40%] mx-auto text-xl xl:text-xl md:text-2xl theme-font-bold uppercase mb-14">
          {t('environmentalMonitoringPage.authorizedDealer')}
        </h2>

        <LeftRight
          sectionClass="pb-10"
          titleClass="text-gray-900"
          isLeft={true}
          textPosition="justify-center"
          descriptionPosition="text-center"
          imgClass="w-[85%] mx-auto"
          descriptionList={[
            t('environmentalMonitoringPage.dataCenterImportance'),
            t('environmentalMonitoringPage.monitoringBenefits'),
          ]}
          icon={false}
          image={require(`../../assets/images/products/pages/environmental-monitoring/1.png`)}
        />

        <h2 className="text-center md:w-[40%] mx-auto text-xl xl:text-xl md:text-2xl theme-font-bold uppercase mb-14">
          {t('environmentalMonitoringPage.sensorsMain')}
        </h2>

        <LeftRight
          sectionClass="pb-10"
          titleClass="text-gray-900"
          isLeft={false}
          textPosition="justify-center"
          descriptionPosition="text-center"
          imgClass="w-[85%] mx-auto"
          descriptionList={[
            t('environmentalMonitoringPage.sensorsTemperature'),
            t('environmentalMonitoringPage.sensorsHumidity'),
            t('environmentalMonitoringPage.sensorsWaterLeakage'),
            t('environmentalMonitoringPage.sensorsAirflow'),
            t('environmentalMonitoringPage.sensorsSecurity'),
            t('environmentalMonitoringPage.sensorsAcDetection'),
            t('environmentalMonitoringPage.sensorsSmoke'),
          ]}
          icon={true}
          image={require(`../../assets/images/products/pages/environmental-monitoring/2.png`)}
        />

        <LeftRight
          subtitle={t('environmentalMonitoringPage.alertsIntro')}
          sectionClass="pb-10"
          titleClass="text-gray-900"
          isLeft={true}
          textPosition="justify-center"
          descriptionPosition="text-center"
          imgClass="w-[85%] mx-auto"
          descriptionList={[
            t('environmentalMonitoringPage.alertsSnmp'),
            t('environmentalMonitoringPage.alertsEmail'),
            t('environmentalMonitoringPage.alertsSms'),
            t('environmentalMonitoringPage.alertsCall'),
          ]}
          icon={true}
          image={require(`../../assets/images/products/pages/environmental-monitoring/2.png`)}
        />

        <LeftRight
          title={t('environmentalMonitoringPage.featuresTitle')}
          sectionClass="pb-10"
          titleClass="text-gray-900"
          isLeft={true}
          textPosition="justify-center"
          descriptionPosition="text-center"
          imgClass="w-[85%] mx-auto"
          secondListGroup={[
            t('environmentalMonitoringPage.featuresDevice'),
            t('environmentalMonitoringPage.featuresIpBased'),
            t('environmentalMonitoringPage.featuresPorts'),
            t('environmentalMonitoringPage.featuresMountable'),
            t('environmentalMonitoringPage.featuresProbeDetection'),
            t('environmentalMonitoringPage.featuresLedStatus'),
            t('environmentalMonitoringPage.featuresEthernet'),
            t('environmentalMonitoringPage.featuresPowerConsumption'),
            t('environmentalMonitoringPage.featuresOutputSignals'),
            t('environmentalMonitoringPage.environmentSpecs'),
            t('environmentalMonitoringPage.environmentTemp'),
            t('environmentalMonitoringPage.environmentHumidity'),
            t('environmentalMonitoringPage.warranty'),
          ]}
          descriptionList={[
            t('environmentalMonitoringPage.uiFeaturesBrowser'),
            t('environmentalMonitoringPage.uiFeaturesEmail'),
            t('environmentalMonitoringPage.uiFeaturesLogin'),
            t('environmentalMonitoringPage.uiFeaturesUserAccounts'),
            t('environmentalMonitoringPage.uiFeaturesGraphReport'),
            t('environmentalMonitoringPage.uiFeaturesExport'),
            t('environmentalMonitoringPage.uiFeaturesSms'),
            t('environmentalMonitoringPage.uiFeaturesAlarm'),
          ]}
          icon={false}
        />
      </div>
      <div className="bg-slate-50 pt-20">
        <div className="md:w-theme-container w-mobile-container mx-auto">
          <div className="flex items-center justify-center text-center md:text-lg">
            {t('environmentalMonitoringPage.monitoringBenefits')}
          </div>
          <div className="card bg-white rounded-xl my-10 p-6">
            <div className="grid md:grid-cols-[250px_1fr] grid-cols-1 gap-10">
              <div>
                <img
                  src={require(`../../assets/images/products/pages/environmental-monitoring/4.png`)}
                  alt=""
                />
              </div>
              <div>
                <p className="mb-5">{t('environmentalMonitoringPage.sensorTitle')}</p>
                <p>{t('environmentalMonitoringPage.sensorDescription')}</p>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 pb-10">
            {productCards.map((card) => (
              <div key={card.id} className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 overflow-hidden">
                <div className="flex flex-col h-full">
                  {/* Image Section */}
                  <div className="w-full h-48 md:h-56 overflow-hidden flex items-center justify-center">
                    <img
                      src={require(`../../assets/images/products/pages/environmental-monitoring/products/${card.imgName}`)}
                      alt={t(card.translateKeys.title)}
                      className=""
                    />
                  </div>
                  {/* Content Section */}
                  <div className="p-5 flex flex-col flex-grow">
                    <h3 className="text-xl font-bold text-gray-800 mb-2 text-center">
                      {t(`environmentalMonitoringPage.${card.translateKeys.title}`)}
                    </h3>
                    <p className="text-gray-600 text-sm text-center leading-relaxed flex-grow">
                      {t(`environmentalMonitoringPage.${card.translateKeys.description}`)}
                    </p>
                  </div>
                </div>
              </div>

            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnvironmentalMonitoring;
